import traverse from 'traverse'

/**
 * Extracts all liveKeys from a GraphQL query result
 */
export function getLiveKeysOfQuery(query: object) {
  const liveKeys: string[] = []
  traverse(query).forEach(function (value) {
    if (this.key?.endsWith('_liveKeys')) {
      liveKeys.push(...value)
    }
  })
  return liveKeys
}
